import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ColumnModel } from "@syncfusion/ej2-vue-grids";
import { getCurrentInstance, onBeforeMount, ref } from "vue";
import BaseGridView from "../../common/BaseGridView.Component.vue";
import { SearchOption, TemplateDef } from "../../common/CommonInterfaces";
import { GridConfig } from "../../common/Constants";


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierComponent',
  setup(__props) {

let columnDef = ref([] as ColumnModel[]);
const templateDef: TemplateDef = {
  prefix: "supplier",
  columnNames: ["isActive"],
};
const _searchOptions = {
  fields: [
    "company.Name",
    "name",
    "contactCreatedDateTimeOffset",
    "currencyCode",
    "emailAddress",
    "lastChangedDateTimeOffset",
    "phoneNumber",
    "websiteUrl",
  ],
  operator: "contains",
  ignoreCase: true,
} as SearchOption;

const app = getCurrentInstance();

onBeforeMount(() => {
  assignColumnDef();
});

const assignColumnDef = () => {
  const instance = app?.proxy;
  columnDef.value = [
    {
      field: "companyName",
      headerText: instance?.$t("companyName"),
      textAlign: "Center",

    },
    { field: "name", headerText: instance?.$t("name") },
    { field: "currencyCode", headerText: instance?.$t("currencyCode") },
    {
      field: "contactCreatedDateTimeOffset",
      headerText: instance?.$t("contactCreatedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "emailAddress", headerText: instance?.$t("emailAddress") },
    {
      field: "isActive",
      headerText: instance?.$t("status"),
      template: "supplier_isActive",
    },
    {
      field: "lastChangedDateTimeOffset",
      headerText: instance?.$t("lastChangedDate"),
      type: "date",
      format: GridConfig.dateFormat,
    },
    { field: "phoneNumber", headerText: instance?.$t("phoneNumber") },
    { field: "websiteUrl", headerText: instance?.$t("website") },
  ];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGridView, {
    endpoint: "v1/Supplier/GetData",
    pageTitle: _ctx.$t('Suppliers'),
    columnDef: (_unref(columnDef) as Array<ColumnModel>),
    searchOptions: _searchOptions,
    templateDef: templateDef
  }, {
    supplier_isActive: _withCtx(({ rowData }) => [
      _createElementVNode("span", {
        class: _normalizeClass(rowData.value ? 'badge badge-success' : 'badge badge-danger')
      }, _toDisplayString(rowData.value ? "Active" : "Inactive"), 3)
    ]),
    _: 1
  }, 8, ["pageTitle", "columnDef"]))
}
}

})